import { HttpClient } from '@angular/common/http';

import {
    INgxFileUploadFile,
    INgxFileUploadRequest,
    NgxFileUploadFactory,
    NgxFileUploadFile,
    NgxFileUploadOptions,
    NgxFileUploadRequest,
    NgxFileUploadValidation
} from '@ngx-file-upload/core';

export class MediahavenFileUploadRequest extends NgxFileUploadRequest {
    constructor(
        httpClient: HttpClient,
        files: NgxFileUploadFile | NgxFileUploadFile[],
        options: NgxFileUploadOptions,
        formData?: FormData
    ) {
        super(httpClient, files, options);
        // Hack to override private method
        this['createUploadBody'] = () => {
            return formData ?? super['createUploadBody']();
        };
    }
}

// https://github.com/r-hannuschka/ngx-fileupload/blob/master/src/projects/core/src/lib/upload/src/upload.factory.ts
export class MediahavenFileUploadFactory implements NgxFileUploadFactory {
    public constructor(private httpClient: HttpClient) {}

    public createMediahavenUploadRequest(
        options: NgxFileUploadOptions,
        formData: FormData,
        validator?: NgxFileUploadValidation
    ): INgxFileUploadRequest {
        const file: File | undefined = formData.get('file') as File | undefined;

        if (!file) {
            throw Error('File property not provided in formData');
        }

        const model: NgxFileUploadFile = new NgxFileUploadFile(file);
        if (validator) {
            model.validationErrors = 'validate' in validator ? validator.validate(file) : validator(file);
        }

        return new MediahavenFileUploadRequest(this.httpClient, model, options, formData);
    }

    public createUploadRequest(
        file: File | File[],
        options: NgxFileUploadOptions,
        validator?: NgxFileUploadValidation
    ) {
        const files = Array.isArray(file) ? file : [file];

        if (files.length) {
            const fileModels: INgxFileUploadFile[] = files.map(file => {
                const model = new NgxFileUploadFile(file);
                if (validator) {
                    model.validationErrors = 'validate' in validator ? validator.validate(file) : validator(file);
                }
                return model;
            });

            // * create one requests which holds all files
            return new NgxFileUploadRequest(this.httpClient, fileModels, options);
        }

        return null;
    }
}
